import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { playChime } from "@/lib/notifications";

const POLL_MS = 6000;
let count = 0;
const listeners = new Set();
const setCount = (n) => { count = n; listeners.forEach((l) => l(n)); };

export function useChatUnread() {
  const [n, setN] = useState(count);
  useEffect(() => { listeners.add(setN); return () => listeners.delete(setN); }, []);
  return n;
}

export const refreshChatUnread = () => window.dispatchEvent(new Event("bazaro-chat"));

export function ChatWatcher() {
  const { user } = useAuth();
  const userId = user?.user_id;
  useEffect(() => {
    if (!userId) { setCount(0); return undefined; }
    let alive = true;
    let first = true;
    const load = async () => {
      try {
        const { data } = await api.get("/chat/unread-count");
        if (!alive) return;
        if (!first && data.count > count) { playChime(); window.dispatchEvent(new Event("bazaro-new-message")); }
        first = false;
        setCount(data.count);
      } catch { /* ignore */ }
    };
    load();
    const id = setInterval(load, POLL_MS);
    window.addEventListener("bazaro-chat", load);
    return () => { alive = false; clearInterval(id); window.removeEventListener("bazaro-chat", load); };
  }, [userId]);
  return null;
}
